import type {ReactNode} from 'react'
import {Link} from 'react-router-dom'
import {useTranslation} from 'react-i18next'
import {PageHeading} from '@/components/page-heading'
import {PerfilCargoTabs} from '@/components/perfil-cargo-tabs'

/** El título es el cargo, no la sección: la pestaña activa ya dice cuál se mira (T1). */
export function PerfilCargoChrome({
  businessId,
  positionId,
  cargo,
  testId,
  accion,
  children,
}: {
  businessId: string
  positionId: string
  cargo: string | undefined
  testId: string
  accion?: ReactNode
  children: ReactNode
}) {
  const {t} = useTranslation()
  return (
    <div className="space-y-5" data-testid={testId}>
      <Link className="text-sm underline" to={`/businesses/${businessId}/sgsst/perfiles-cargo`}>
        {t('perfilCargo.detalle.volver')}
      </Link>
      <PageHeading title={cargo ?? ''} accion={accion} />
      <PerfilCargoTabs businessId={businessId} positionId={positionId} />
      {children}
    </div>
  )
}
